// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__BUANO","author":"Quote_author__PO_Jm","text":"Quote_text__U_nOi","name":"Quote_name__RDgLx","position":"Quote_position__KE8oh"};